import { NodeProps } from "reactflow";
import NodeCard from "../NodeCard";
import { FlowModuleItemType } from "@packages/flow-core/module";
import styles from "./index.less";
import RenderInput from "../render/RenderInput";
import { memo, useEffect, useMemo } from "react";
import { RenderInputProps } from "../render/RenderInput/types";
import TextInput from "../render/RenderInput/templates/TextInput";
// import SelectKnowledge from '../render/RenderInput/templates/SelectKnowledge';
import Divider from "../Divider";
import RenderOutput from "../render/RenderOutput";
import { useFlow } from "../FlowEdit/useFlow";
import { FlowNodeInputTypeEnum } from "@packages/flow-core/module/node/constants";

// 雀鲷不支持选择知识库
const KnowledgeAll = ({ moduleId, inputs }: RenderInputProps) => {
  const { updateNodeValue } = useFlow();
  const knowledgeNameInput = useMemo(() => {
    return inputs?.find((item) => item.key === "knowledgeName");
  }, [inputs]);

  // const selectedListInput = useMemo(() => {
  //   return inputs?.find((item) => item.key === 'selectedList');
  // }, [inputs]);

  useEffect(() => {
    let totalValue: any[] = [];
    if (knowledgeNameInput?.value) {
      totalValue.push(knowledgeNameInput.value);
    }
    // if (selectedListInput?.value) {
    //   totalValue.push(...(selectedListInput.value as any[]));
    // }
    updateNodeValue(moduleId, "selectedKnowledgeAll", totalValue);
  }, [knowledgeNameInput?.value]);

  return (
    <div>
      <div className={styles["mb-7"]}>
        <TextInput
          item={knowledgeNameInput!}
          inputs={inputs}
          moduleId={moduleId}
        />
      </div>
      {/* <SelectKnowledge item={selectedListInput!} inputs={inputs} moduleId={moduleId} /> */}
    </div>
  );
};

export default memo(function NodeKnowledgeBase({
  selected,
  data,
}: NodeProps<FlowModuleItemType>) {
  const { moduleId, inputs, outputs } = data;

  return (
    <NodeCard {...data} selected={selected}>
      <Divider text="输入" />
      <div className={styles.content}>
        <RenderInput
          moduleId={moduleId}
          flowInputList={inputs}
          CustomComponent={{
            [FlowNodeInputTypeEnum.selectedKnowledgeAll]: KnowledgeAll,
          }}
        />
      </div>
      <Divider text="输出" />
      <div className={styles.content}>
        <RenderOutput moduleId={moduleId} flowOutputList={outputs} />
      </div>
    </NodeCard>
  );
});
